module.exports = __webpack_public_path__ + "img/Logo-System.b3470414.png";